import { QUERY_STATUSES } from 'src/constants/config';

// Status categories and utilities for Reports
export const WIN_STATUSES = ['successful', 'successful placement', 'pending publication', 'paid editorial', 'pendingPublication', 'paidEditorial'];

export const IN_PROGRESS_STATUSES = [
  'submitted to journalist',
  'coordinating next steps',
  'submittedToJournalist',
  'pending',
  'awaiting',
  'clientApproved',
  'clientNeedsEdits',
  'needsFollowUp',
  'inquireInterest',
  'client passed',
  'clientPassed',
  'journalist passed',
  'journalistPassed',
  'insights not included',
  'insightsNotIncluded',
  'repurpose',
  'repurposed',
  'draft',
];

// Format status display names
export const formatStatusDisplay = (status) => {
  const statusMap = {
    // Current status options (lowercase with spaces)
    'submitted to journalist': 'Proactive outreach',
    'coordinating next steps': 'Coordinating next steps',
    'pending publication': 'Pending publication',
    'successful placement': 'Successful placement',
    'client passed': 'Client passed',
    'journalist passed': 'Journalist passed',
    'insights not included': 'Insights not included',
    'paid editorial': 'Paid editorial',
    repurpose: 'Repurpose',

    // Current status options (camelCase variants)
    submittedToJournalist: 'Proactive outreach',
    pendingPublication: 'Pending publication',
    successfulPlacement: 'Successful placement',
    clientPassed: 'Client passed',
    journalistPassed: 'Journalist passed',
    insightsNotIncluded: 'Insights not included',
    paidEditorial: 'Paid editorial',
    clientApproved: 'Client approved',
    clientNeedsEdits: 'Client needs edits',
    needsFollowUp: 'Needs follow up',
    inquireInterest: 'Inquire interest',
    repurposed: 'Repurposed',

    // Legacy status options for backwards compatibility
    successful: 'Successful',
    'pending response': 'Pending Response',
    draft: 'Draft',
    awaiting: 'Awaiting',
    pending: 'Pending',
  };
  return statusMap[status] || status.charAt(0).toUpperCase() + status.slice(1);
};

// Legacy status arrays for backwards compatibility
const LEGACY_WIN_STATUSES = ['successful', 'paid editorial'];
const LEGACY_IN_PROGRESS_STATUSES = ['draft', 'awaiting', 'pending', 'pending response'];

// Check if a status is a win status
export const isWinStatus = (status) => WIN_STATUSES.includes(status) || LEGACY_WIN_STATUSES.includes(status);

// Check if a status is in progress
export const isInProgressStatus = (status) => IN_PROGRESS_STATUSES.includes(status) || LEGACY_IN_PROGRESS_STATUSES.includes(status);

// Status priority order based on QUERY_STATUSES color hierarchy
// success (highest) > neutral > info > warning > error (lowest)
const STATUS_PRIORITY = {
  success: 1,
  neutral: 2,
  info: 3,
  purple: 4,
  warning: 5,
  brown: 6,
  error: 7,
};

// Get status priority for sorting (lower number = higher priority)
export const getStatusPriority = (status) => {
  const statusConfig = QUERY_STATUSES[status];
  if (!statusConfig) return 999; // Unknown statuses go to the end
  return STATUS_PRIORITY[statusConfig.color] || 999;
};

// Sort efforts by status priority (success first) then chronologically (newest first)
export const sortEffortsByStatusAndDate = (efforts, dateField = 'updateTime') => {
  return [...efforts].sort((a, b) => {
    // First sort by status priority (success > neutral > info > warning > error)
    const priorityA = getStatusPriority(a.status);
    const priorityB = getStatusPriority(b.status);

    if (priorityA !== priorityB) {
      return priorityA - priorityB; // Lower priority number = higher in list
    }

    // If same status priority, sort chronologically (newest first)
    const dateA = new Date(a[dateField]);
    const dateB = new Date(b[dateField]);
    return dateB - dateA; // Newer dates first
  });
};
